import { OdataManager } from '@/api/odata/odata-manager';
import { ProjectSection } from '@/api/model/interfaces';

export default class ProjectSectionOdata extends OdataManager<ProjectSection> {}
